define('bizzabo/views/main/PartnersView',[
    'jquery',
    'backbone',
    'underscore',
    'bizzabo/models/Global',
    'bizzabo/bzapi',
    'bizzabo/utils',
    'bizzabo/consts',
    'bizzabo/views/main/MainView',
    'hbars!bizzabo/templates/partners'
], function(
    $,
    Backbone,
    _,
    Global,
    BZAPI,
    UTILS,
    Consts,
    MainView,
    template
    ) {

    var PartnersView = MainView.extend({

        tabClass : Consts.UI.tabClasses.PARTNERS,

        prepare : function() {
            this.prepareModels([this.model]);
        },

        render : function() {
            this.renderMainView({
                hasDetails : true,
                detailsSizeClass : "leftDefined",
                startWithHiddenDetails : true
            });

            this.putContentView(new PartnersContentView({
                model : this.model,
                partnersView : this
            }));

            this.switchRightPanelView();
        },

        remove : function() {
            this.removeMainView();
        },

        switchRightPanelView : function(name) {
            var paramsObject = {
                partnersView : this
            };
            if (name) {
                paramsObject["name"] = name;
            }
            var partnerDetailsView = new PartnerDetailsView(paramsObject);
            this.putRightPanelView(partnerDetailsView);
        }
    });

    var PartnersContentView = Backbone.View.extend({

        events : {
            'click article' : 'openPartnerData'
        },

        initialize : function() {
        },

        remove : function() {
            Global.appView.$('.main').removeClass('mainPartnersAddBack');

            this.off();
            this.$el.remove();
        },

        prepare : function() {
            this.prepareModels([this.model]);
        },

        onPageLoad : function() {
        },

        render : function() {
            var html = template({
                "leftPartnersMenu" : true
            });
            this.$el.html(html);

            Global.appView.$('.main').addClass('mainPartnersAddBack');
            return this;
        },

        openPartnerData : function(eventObject) {
            // if the focused partner was clicked- close
            var focusedArticleEl = this.$(".focused");
            var clickedArticleEl = this.$(eventObject.target).closest("article");
            if (focusedArticleEl.is(clickedArticleEl)) {
                this.options.partnersView.toggleDetails("Same partner clicked");
                return;
            }

            // un-focus current partner
            focusedArticleEl.removeClass("focused");

            // focus clicked partner
            clickedArticleEl.addClass("focused");

            // find clicked partner's name
            var nameEl = clickedArticleEl.find("div.rightDiv p.partnersName");
            var name = nameEl.html();

            // slightly shift right panel and fade out current content
            var partnersView = this.options.partnersView;
            partnersView.isDetailsOpen() && partnersView.$el.addClass("slightlyShiftDetailsRight");
            partnersView.rightPanelView.$el.fadeOut(150, function() {

                // switch content and come back in
                partnersView.removeRightPanelView();
                partnersView.switchRightPanelView(name);
                partnersView.openDetails(true);
                partnersView.$el.removeClass("slightlyShiftDetailsRight");
                partnersView.$el.find(".details-content>div").css("height", "100%");
            });
        }
    });

    var PartnerDetailsView = Backbone.View.extend({

        stillEmpty : true,

        initialize : function() {
        },

        remove : function() {
            this.off();
            this.$el.remove();
        },

        render : function() {
            if (_.isUndefined(this.options.name)) {
                return this;
            }
            this.stillEmpty = false;

            var model = {};
            model[this.options.name] = true;

            var html = template(model);
            this.$el.html(html);
            return this;
        }
    });

    return PartnersView;
});
